{
  "items": [
    {
      "label": "Product",
      "href": "/features",
      "details": {
        "columns": [
          {
            "title": "Features",
            "items": [
              {
                "label": "Calendar",
                "href": "/features/calendar",
                "description": "Your real week with tasks and context"
              },
              {
                "label": "Stickers",
                "href": "/features/stickers",
                "description": "Mark the days that matter"
              },
              {
                "label": "Sheets",
                "href": "/features/sheets",
                "description": "Events, tasks, context, and formulas"
              },
              {
                "label": "Integrations",
                "href": "/features/integrations",
                "description": "Google Calendar, Garmin, Whoop, and Weather"
              },
              {
                "label": "AI Chat",
                "href": "/features/ai-chat",
                "description": "Ask for a view you can use"
              }
            ]
          },
          {
            "title": "Jobs",
            "items": [
              {
                "label": "Plan the week",
                "href": "/jobs/plan-the-week",
                "description": "See tasks beside the week"
              },
              {
                "label": "Travel across timezones",
                "href": "/jobs/travel-timezones",
                "description": "Keep time and place visible"
              },
              {
                "label": "Mark the week",
                "href": "/jobs/mark-the-week",
                "description": "Make important days stand out"
              }
            ]
          },
          {
            "title": "",
            "items": []
          }
        ],
        "image": {
          "src": "lona://splat/reef-1"
        }
      }
    },
    {
      "label": "Solutions",
      "href": "/solutions",
      "details": {
        "columns": [
          {
            "title": "Use cases",
            "items": [
              {
                "label": "Timezone Planning",
                "href": "/solutions/timezone",
                "description": "Plan across places without mental conversion"
              },
              {
                "label": "Health & Fitness",
                "href": "/solutions/health-fitness",
                "description": "Explain recovery with calendar context"
              },
              {
                "label": "Personal Analytics",
                "href": "/solutions/personal-analytics",
                "description": "Understand patterns across real days"
              },
              {
                "label": "Team Scheduling",
                "href": "/solutions/team-scheduling",
                "description": "Shared availability with privacy boundaries"
              }
            ]
          },
          {
            "title": "For",
            "items": [
              {
                "label": "Knowledge Workers",
                "href": "/for/knowledge-workers",
                "description": "Plan from weekly capacity"
              },
              {
                "label": "Travelers",
                "href": "/for/travelers",
                "description": "Keep time zones honest"
              },
              {
                "label": "Athletes",
                "href": "/for/athletes",
                "description": "See training beside life"
              }
            ]
          },
          {
            "title": "",
            "items": []
          }
        ],
        "image": {
          "src": "lona://splat/sunset-sea-1"
        }
      }
    },
    {
      "label": "Resources",
      "href": "/blog",
      "details": {
        "columns": [
          {
            "title": "Learn",
            "items": [
              {
                "label": "Blog",
                "href": "/blog",
                "description": "Practical guides for readable weeks"
              },
              {
                "label": "Docs",
                "href": "/docs",
                "description": "Guides and references"
              }
            ]
          },
          {
            "title": "",
            "items": []
          },
          {
            "title": "",
            "items": []
          }
        ]
      }
    },
    {
      "label": "Pricing",
      "href": "/pricing"
    }
  ],
  "cta": {
    "label": "Get started",
    "href": "/signin"
  }
}
